export function cartBadgeCount(cartCount: number, pendingPaymentCount: number): number {
  return cartCount + pendingPaymentCount;
}

export function formatCartBadge(count: number): string {
  return count > 9 ? "9+" : String(count);
}

export function cartNavPath(cartCount: number, pendingPaymentCount: number): string {
  if (pendingPaymentCount > 0 && cartCount === 0) return "/cart?tab=pending";
  return "/cart";
}

export function cartNavAriaLabel(cartCount: number, pendingPaymentCount: number): string {
  const parts: string[] = [];
  if (cartCount > 0) parts.push(`${cartCount} item${cartCount === 1 ? "" : "s"}`);
  if (pendingPaymentCount > 0) {
    parts.push(`${pendingPaymentCount} pending payment${pendingPaymentCount === 1 ? "" : "s"}`);
  }
  return parts.length ? `Cart (${parts.join(", ")})` : "Cart";
}
